import React from "react";
import { View, Text } from "@react-pdf/renderer";

const money = (n) => `$${Number(n).toFixed(2)}`;

export default function ItbmsSection({ S, itbmsRows }) {
  return (
    <View style={S.half}>
      <View style={S.miniTable}>
        <View style={S.miniHead}>
          <Text style={S.miniHeadTxt}>Desglose ITBMS</Text>
        </View>

        <View style={S.miniRow}>
          <Text style={[S.td, { flex: 1, fontWeight: 700 }]}>
            Monto Base
          </Text>
          <Text style={[S.td, { width: 60, textAlign: "right", fontWeight: 700 }]}>
            %
          </Text>
          <Text style={[S.td, { width: 70, textAlign: "right", fontWeight: 700 }]}>
            Impuesto
          </Text>
        </View>

        {itbmsRows.map((r, i) => (
          <View key={i} style={S.miniRow}>
            <Text style={[S.td, { flex: 1 }]}>{money(r.montoBase)}</Text>
            <Text style={[S.td, { width: 60, textAlign: "right" }]}>
              {Number(r.porcentaje).toFixed(2)}
            </Text>
            <Text style={[S.td, { width: 70, textAlign: "right" }]}>
              {money(r.impuesto)}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}